/**
 * @fileoverview
 * Pinia Setup Store에서 기본적으로 제공되지 않는 `$reset` 기능을 구현하는 유틸리티.
 *
 * @description
 * - Setup Store의 `ref` 상태값을 초기값으로 자동 저장
 * - `$reset` 메서드를 통해 초기 상태 복원 기능 제공
 * - Deep Clone(structuredClone)을 사용하여 참조형 데이터의 변경 방지
 * - 모든 Pinia Setup Store를 정의할 때 `createResetStore`로 래핑하여 사용
 * - Option Store와 동일한 상태 초기화 패턴 지원
 *
 * @remarks
 * - 초기값 저장은 ref 타입만 가능하며 computed 속성은 제외됨
 * - computed 속성이 isRef에서 true로 반환되므로 effect 속성으로 추가 필터링 필요
 * - structuredClone 사용으로 initialState는 직렬화 가능한 객체만 저장 가능
 * - DOM 노드, 함수, Symbol 등은 structuredClone에서 오류 발생할 수 있음
 * - 순환 참조가 있는 객체는 정상 복제되나 성능에 영향을 줄 수 있음
 *
 * @author 최재영
 * @created 2025-01-17
 */

/**********************************
 * Store Module Definition
 **********************************/
export const createResetStore = (useStore) => {
  return () => {
    const store = useStore(); // 스토어 객체 복제
    store.initialState = {}; //초기값 담을 객체 선언

    // 스토어 초기값 저장 (ref 타입만 저장)
    Object.keys(store).forEach((_key) => {
      // computed 변수도 isRef에서 true가 반환되기 때문에 추가로 effect 체크(effect는 computed변수에만 있음)
      if (isRef(store[_key]) && !store[_key].effect) {
        // toRaw : ref 객체를 원시 객체로 변환
        store.initialState[_key] = toRaw(store[_key].value);
      }
    });

    // $reset 함수 추가
    store.$reset = () => {
      Object.keys(store.initialState).forEach((_key) => {
        store[_key].value = structuredClone(store.initialState[_key]);
      });
    };

    return store;
  };
};
